import { notEmpty } from 'ha/utils/notEmpty';

export default function prepareFormData(fields) {
  const formData = new FormData();

  Object.keys(fields)
    .filter(key => notEmpty(fields[key]))
    .forEach(key => formData.append(key, fields[key]));

  return formData;
}
